// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2026-05-27 14:18:05 +0200 (Wed, 27 May 2026) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 163319 $
// Purpose     : debug actions
// =============================================================================
// ---Third-party imports
import { createAction } from 'redux-actions';
import now from 'performance-now';
// ---Framework imports
import { isString, isNumber, isBoolean } from 'ldash';
import { COPY2PAYLOAD, SILENT, GENERATOR, combine } from 'uix/actions';
import log from 'uix/logging';
// ---Exports
export const goRandomId = createAction('GO_RANDOM_ID', COPY2PAYLOAD);
export const clearHistories = createAction('CLEAR_HISTORIES');
export const triggerSagaError = createAction('TRIGGER_SAGA_ERROR');
export const setDebug = createAction('SET_DEBUG', (on)=>({
        on
    }));
// payload should be a dict, merge into root.debug
export const setDebugData = createAction('SET_DEBUG_DATA', COPY2PAYLOAD);
export const interpreterCmd = createAction('INTERPRETER_CMD', ({ cmd, multiline, threaded })=>({
        cmd,
        multiline,
        threaded
    }));
export const setInterpreterOutput = createAction('INTERPRETER_OUTPUT', (output)=>({
        output
    }));
export const getApiAvailability = createAction('GET_API_AVAILABILITY', (urls)=>({
        urls
    }), SILENT);
export const switchApiUrl = createAction('SWITCH_API_URL', (apiurl)=>({
        apiurl
    }));
// react-refresh-webpack-plugin
export const hotReload = createAction('HOT_RELOAD', (status)=>({
        status
    }));
// webpack dev server (WDS) hot module reload (HRM)
export const hotUpdate = createAction('HOT_UPDATE', (hash)=>({
        hash
    }), SILENT);
// this action needs not to be dispatched to have an effect
// XXX: why?
export const pprint = createAction('PPRINT', (data, expanded = null)=>{
    if (isString(data)) {
        return {
            string: data,
            __expanded__: expanded
        };
    } else if (isBoolean(data)) {
        return {
            bool: data,
            __expanded__: expanded
        };
    } else if (isNumber(data)) {
        return {
            number: data,
            __expanded__: expanded
        };
    } else {
        return {
            ...data,
            __expanded__: expanded
        };
    }
}, ()=>({
        silent: true
    }));
export const apiCallStart = createAction('API_CALL_START', ({ path, params })=>({
        path,
        params,
        ts: now()
    }), combine(SILENT, GENERATOR('apiCallId')));
export const apiCallEnd = createAction('API_CALL_END', COPY2PAYLOAD, SILENT);
